import { APP_VERSION, COUNTRY_CODE, EnvironmentType } from "./environment.type";

export const environment: EnvironmentType = {
  placement: "prod",
  production: true,
  route_hash: false,
  timezone: "America/Santiago",
  code: COUNTRY_CODE.cl,
  currency: "CLP",
  grammar: "es",
  lang: "es",
  phone_length: 9,
  max_phone_length: 15,
  max_tip: 40000,
  phone_prefix: "+56",
  gateway: {
    base_url: "https://services.rappi.cl",
    csv_prefix: "/api/cargo-api-gateway/csv/portal/",
    location_gateway_prefix: "/api/cargo-api-gateway/core-maps/address/",
    gateway_prefix: "/api/cargo-api-gateway/portal/",
    settlement_prefix: "/api/cargo-api-gateway/portal/settlement/",
    cashless_prefix: "/api/ms/cargo-cashless/",
    maps_prefix: "/api/maps/v1/",
  },
  logoUrl: "https://cargo-core-api.s3.us-west-2.amazonaws.com/cl/cargo-logos/",
  trackingUrl: "cargo-tracking.rappi.cl/",
  aws_location: {
    api_key:
      "v1.public.eyJqdGkiOiIwNWExNjBkMy01MDc3LTQ2OWQtOWVjZi00NjcxNzE0Yjk4NzMifY9ABMDdF9VbkIJrDhwFnbcFHcPKi_Twy6D8dggPnUKKVR1d965j7MjbeZMO087H_KxAykL695bLhC6p7QajOWUUN2AHZ0Uhro674Le-W-A1Uos8jNoXMAtMaGlupgFdcNjXRtnt6qlGFyNyypLtYoT2nOPT3CRjtrYsSLB1f5SSPhgC7SAKkBp3SLXKpIm2N9hdpqPwhdL4x2lx5gCf_A4G30USYciV_N_pCbQGX1Clzhlr_b3U-0SvkGFCNBvSgX07H8dPsTFkZxXf8ITIkAZQM7WcNc06OXnSTF1HdJYdLry3j-ucefcFWWfpzYXiz8NU9aHEJv7IP4GVQdr-3fE.ZWU0ZWIzMTktMWRhNi00Mzg0LTllMzYtNzlmMDU3MjRmYTkx",
    region: "us-east-1",
    style: "Standard",
    color_scheme: "Light",
  },
  coordsCenter: { lat: -33.45694, lng: -70.64827 },
  currencySymbol: "$",
  decimalPattern: /^[0-9]+([.]\d{0,0})?$/,
  decimalNumber: 0,
  country: {
    defaultLocale: "es-CL",
  },
  localeUrl: "https://cargo-core-api.s3.amazonaws.com/cl/cargo-logos/",
  auth0: {
    client_id: "hDcAOaY9heMYiAxYPvr5Ynt3ZeNybA43",
    client_secret: "OxnMGuC8OXHjYTgznaaKL2ItdOB4xdMj2jpTDbx6au00NQX47lBEdjgGXc6ia2m4",
    domain: "https://login.partners.rappi.com",
  },
  amplitude: {
    key: "032f00f0dfdad881e7391f28f35156f6",
  },
  i18n_version: APP_VERSION,
  kustomer_assistant_id: "664bbe3419e7a2316b52dc7a",
  recaptcha_site_key: "6Le98o0sAAAAAMT-KoXGJs6OW-aYF9sbNdbigJaR",
  amazon_connect: {
    snippet_id:
      "QVFJREFIaGRXUHpDQ0syTWozT3FtUTlKL1lZeW8zbzdUZEQ4Y1A3d0wzMWFuQ0RFM0FIUjdSZEdzTzJWYWV1Ynl4NjY4QmRCQUFBQWJqQnNCZ2txaGtpRzl3MEJCd2FnWHpCZEFnRUFNRmdHQ1NxR1NJYjNEUUVIQVRBZUJnbGdoa2dCWlFNRUFTNHdFUVFNWXRNZ0JBWUpaUHM2NkhSSkFnRVFnQ3NiNFdUQ0xxSVVDVXBTRldTQzlGU0xSanRhYTFXWm5kMG85RWRBNnB6TDV0bnFRRnQ4V1JlVVhDVGg6OmNGZ0IwVjVrUEhIWlIwNDAyN0ZTTmtMcUpseTYvVlI0enFiSkpCWTVDazQxV3BlTmlKN2V6VDUyblpDYmswMjRlS3NIQnlWN2ZiN3NTNmN3UHBFdjczbGVWRDhkMDlBb25sTGgxUVlGcStIcC9wSVlISDhSa2orSjdDQVIwaEJTZEdNQWJML2g1OXIrZ1RNUWhReXFOSTNDS3puS2RRUT0=",
    src: "https://connect-rappi-support-prod.my.connect.aws/connectwidget/static/amazon-connect-chat-interface-client.js",
    script_id: "37223493-6644-445d-bae1-7074a64d629c",
  },
};
